import React, { useMemo } from 'react'
import Card from '@mui/material/Card'
import { ILeadOppProduct } from '@user/store/leadOppProducts'
import { IServiceFrequency } from '@user/store/serviceFrequency'
import { ServiceSectionDetails } from '@user/components/Agreements/AgreementFormPacketDialog/ServiceSectionDetails'
import { useFormikContext } from 'formik'
import {
  CreateAgreementFormPacketModel,
  CreateAgreementTemplateDetails,
} from '@user/components/Agreements/AgreementFormPacketDialog/typings'
import Typography from '@mui/material/Typography'

interface Props {
  service: ILeadOppProduct
  agreementServices: (ILeadOppProduct & { disabled?: boolean })[]
  onChangeService: (service: ILeadOppProduct) => void
  serviceFrequencies: IServiceFrequency[]
}

export function AddServiceSection(props: Props) {
  const { service, agreementServices, onChangeService, serviceFrequencies } =
    props

  const { values, submitCount } =
    useFormikContext<CreateAgreementFormPacketModel>()

  const { templates } = values

  const serviceAdded = useMemo(() => {
    const services: number[] = []
    if (submitCount > 0) {
      templates.map((template: CreateAgreementTemplateDetails) =>
        template.services?.map((sv) => {
          if (sv.id === service.id) services.push(sv.id)
        }),
      )
      return services.length > 0
    }
    return true
  }, [service.id, submitCount, templates])

  return (
    <>
      <Card
        sx={{
          paddingX: 1.5,
          paddingY: 1,
          width: `100%`,
          border: `1px solid ${!serviceAdded ? '#D63B1F' : '#E0E0E0'}`,
          mb: 1,
        }}
        variant="outlined"
      >
        <ServiceSectionDetails
          agreementServices={agreementServices}
          onChangeService={onChangeService}
          serviceFrequencies={serviceFrequencies}
          service={service}
        />
      </Card>
      {!serviceAdded && (
        <Typography
          variant="caption"
          sx={{
            color: (theme) => theme.palette.error.dark,
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            marginTop: -1,
          }}
        >
          {service.name} - {service.description} must be added to an agreement
        </Typography>
      )}
    </>
  )
}
